import { Component, OnInit } from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';

@Component({
  selector: 'app-modal-planning-hq-help',
  templateUrl: './modal-planning-hq-help.component.html',
  styles: []
})
export class ModalPlanningHqHelpComponent extends ExcTranslation implements OnInit {
  colorFC = {
    CANCELLED: 'rgba(250, 169, 51, 0.9)',
    DONE: 'rgba(3, 181, 56, 0.9)',
    INPROG: 'rgba(88, 200, 224, 0.9)',
    EXPIRED: 'rgba(250, 169, 51, 0.9)',
    REJECTED: 'rgba(201, 48, 44, 0.9)',
    PLANNED: 'rgba(32, 83, 148, 0.9)',
    SELECTED: 'rgba(72, 31, 147, 0.9)',
    MOVETO: 'rgba(156, 255, 56, 0.9)',
    MOVEFROM: 'rgba(255, 56, 76, 0.9)'
  };
  colorSC = {
    CANCELLED: 'rgba(250, 169, 51, 0.5)',
    DONE: 'rgba(3, 181, 56, 0.5)',
    INPROG: 'rgba(88, 200, 224, 0.5)',
    EXPIRED: 'rgba(250, 169, 51, 0.5)',
    REJECTED: 'rgba(201, 48, 44, 0.5)',
    PLANNED: 'rgba(32, 83, 148, 0.5)',
    SELECTED: 'rgba(72, 31, 147, 0.5)',
    MOVETO: 'rgba(156, 255, 56, 0.5)',
    MOVEFROM: 'rgba(255, 56, 76, 0.5)'
  };
  constructor(public overlayConfig: OverlayConfig, public overlayRef: OverlayRef) {
    super();
  }
  getKeys(val) {
    return Object.keys(val);
  }
  ngOnInit() {
  }

}
